import { general } from './general';
import { textarea } from './textarea';
import { branch } from './branch';
import { datecontrol } from './datecontrol';
import { collection } from './collection';
import { name } from './name';
import { telephone } from './telephone';
import { email } from './email';

export const reasonleft = (data = {}) => general('reasonleft', {
  Comments: textarea(data?.Comments),
  Reasons: collection(
    ((data.Reasons || {}).items || []).map((y) => {
      const yitem = y.Item || {};

      const phoneNumbers = ((yitem.PhoneNumbers || {}).items || []).map((z) => {
        const zitem = z.Item || {};
        return {
          Item: {
            Telephone: telephone(zitem.Telephone),
          },
        };
      });

      const emails = ((yitem.Emails || {}).items || []).map((z) => {
        const zitem = z.Item || {};
        return {
          Item: {
            Email: email(zitem.Email),
          },
        };
      });

      return {
        Item: {
          Has: branch(yitem.Has),
          Reason: textarea(yitem.Reason),
          Text: textarea(yitem.Text),
          Date: datecontrol(yitem.Date),
          Comments: textarea(yitem.Comments),
          SeveranceTypeComments: textarea(yitem.SeveranceTypeComments),
          NotifiedInPerson: branch(yitem.NotifiedInPerson), // PVQ Only
          NotifiedInWriting: branch(yitem.NotifiedInWriting), // PVQ Only
          GivenByName: name(yitem.GivenByName), // PVQ Only
          PhoneNumbers: collection(phoneNumbers), // PVQ Only
          Emails: collection(emails), // PVQ Only
        },
      };
    })
  ),
  ReasonDescription: textarea(data?.ReasonDescription),
});
